<template>

  <receptionnaire-form
    v-if="receptionnaireFormData"
    :title="title"
    :submit-button-text="submitButtonText"
    :receptionnaire-form-data="receptionnaireFormData"
    @submitReceptionnaireForm="onSubmit($event)"
  />

</template>

<script>

import router from '@/router'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import ReceptionnaireForm from './ReceptionnaireForm.vue'

export default {
  components: {
    ReceptionnaireForm,
  },
  data() {
    return {
      title: "Mise à jour d'un réceptionnaire",
      submitButtonText: 'Modifier',
      receptionnaireFormData: undefined,
    }
  },
  mounted() {
    this.$nextTick(() => {
      const receptionnaireId = router.currentRoute.params.id
      store.dispatch('receptionnaire/fetchReceptionnaire', receptionnaireId)
        .then(response => {
          this.receptionnaireFormData = response.data
        })
    })
  },
  setup() {
    const toast = useToast()

    const onSubmit = formValue => store.dispatch('receptionnaire/updateReceptionnaire', formValue)
      .then(() => {
        router.push({ name: 'receptionnaires-list' })
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Erreur lors de la mise à jour du réceptionnaire',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    return {
      onSubmit,
    }
  },
}
</script>
